//  export const BASE_URL = "http://172.20.10.2:3001/api"
// export const CDN_BASE_URL = "http://172.20.10.2:3001/"
export const CDN_BASE_URL = "https://api.ariyanashop.com/"
export const BASE_URL = "https://api.ariyanashop.com/api"

